import { HealthMetrics } from 'features/Health/containers/MonetisationHealthChartContainer/types/healthMetrics';

export const getFilteredData = (healthMetricsData: HealthMetrics, activeToggles: string[]) => {
  const healthMetricsDataCopy = { ...healthMetricsData };

  Object.keys(healthMetricsData).forEach((key) => {
    const healthMetricsKey = key as keyof HealthMetrics;

    const shouldExcludeHealthMetricsKey = !activeToggles.includes(healthMetricsKey);
    if (shouldExcludeHealthMetricsKey) {
      healthMetricsDataCopy[healthMetricsKey] = {
        overall: healthMetricsData[healthMetricsKey].overall,
        history: [],
      };
    }
  });
  return healthMetricsDataCopy;
};
